import React from 'react';
import { useIntl } from 'react-intl';
import { Option, Select } from 'carbon-react/lib/components/select';

import { PaymentTreatment } from '../../../../types';

interface PaymentTreatmentInputProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  paymentTreatment: PaymentTreatment | null;
}

export const PaymentTreatmentInput = ({ onChange, paymentTreatment }: PaymentTreatmentInputProps) => {
  const intl = useIntl();

  return (
    <Select
      autoComplete="off"
      onChange={onChange}
      value={paymentTreatment || ''}
      size="large"
      label={intl.formatMessage({
        id: 'predict.cash_flow_payment_treatment',
        defaultMessage: 'Cash flow payment treatment'
      })}
      mb={0}
    >
      <Option
        value={PaymentTreatment.SAME_DAY}
        text={intl.formatMessage({ id: 'predict.same_day_payment', defaultMessage: 'Same day payment' })}
      />
      <Option
        value={PaymentTreatment.SINGLE}
        text={intl.formatMessage({ id: 'predict.single_payment', defaultMessage: 'Single payment' })}
      />

      <Option
        value={PaymentTreatment.MULTI_PAYMENT_DAYS}
        text={intl.formatMessage({ id: 'predict.multi_in_days', defaultMessage: 'Multi: in days' })}
      />

      <Option
        value={PaymentTreatment.NON_CASH_TRANSFER}
        text={intl.formatMessage({ id: 'predict.non_cash_transfer', defaultMessage: 'Non cash transfer' })}
      />
    </Select>
  );
};
